import Loading from 'core/components/Loading';
import { useModuleAccess } from 'hooks/useModuleAccess';
import { observer } from 'mobx-react-lite';
import { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import StoreContext from 'stores/context/StoreContext';
import type { ModuleType } from 'models/shop/moduleTypes';
import type { FC, ReactNode } from 'react';

interface RouteModuleGuardProps {
  /**
   * Модуль, который должен быть доступен
   */
  module: ModuleType;
  /**
   * Путь для перенаправления, если модуль недоступен
   */
  fallback?: string;
  /**
   * Дочерние компоненты
   */
  children: ReactNode;
}

/**
 * Guard для проверки доступности модуля на уровне маршрутов
 * Перенаправляет на fallback страницу, если модуль недоступен
 */
const RouteModuleGuard: FC<RouteModuleGuardProps> = observer(
  ({ module, fallback = '/calendar', children }) => {
    const { shopStore, userStore } = useContext(StoreContext);
    const { isModuleEnabled } = useModuleAccess();

    // Проверяем, загружены ли данные пользователя
    if (userStore.userData == null) {
      return <Loading />;
    }

    // Проверяем, загружены ли данные магазина
    if (shopStore.shop == null) {
      return <Loading />;
    }

    // Проверяем, загружены ли настройки модулей
    if (shopStore.shop.settings?.enabledModules == null) {
      return <Loading />;
    }

    if (!isModuleEnabled(module)) {
      return <Navigate to={fallback} replace />;
    }

    return <>{children}</>;
  }
);

export default RouteModuleGuard;
